if (typeof window === 'undefined') {
  console.warn(
    'client-config.js should only be imported in browser environment',
  );
}

if (typeof window.__WEB_CONFIG__ === 'undefined') {
  const error = new Error(
    'window.__WEB_CONFIG__ is not available. Make sure /api/config.js loaded in _document.js',
  );
  console.warn(error);
}

export default window.__WEB_CONFIG__;
